import { Action, createReducer, on } from '@ngrx/store';

import { BrandingState } from '../branding.model';
import { setIsAgravisUser } from './branding.actions';

export const initialState = <BrandingState>{
  isAgravisUser: false,
};

const brandingReducer = createReducer(
  initialState,
  on(setIsAgravisUser, (state, { isAgravisUser }) => ({
    ...state,
    isAgravisUser,
  })),
);

export function reducer(state: BrandingState | undefined, action: Action) {
  return brandingReducer(state, action);
}
